import { createSlice } from '@reduxjs/toolkit';
import { CollectionTriggerWithUser } from '@dill/dill-shared';
import {
  getSupplierCollectionTriggersExtraReducer,
  createCollectionTriggerExtraReducer,
  updateCollectionTriggerExtraReducer,
  deleteCollectionTriggerExtraReducer,
} from '../reducers/collectionTriggerReducers';

export interface CollectionTriggerInitialState {
  loadingList: string[];
  error: string | null;
  triggers: CollectionTriggerWithUser[];
}

const initialState: CollectionTriggerInitialState = {
  loadingList: [],
  error: null,
  triggers: [],
};

export const collectionTriggerSlice = createSlice({
  name: 'collectionTriggers',
  initialState,
  reducers: {
    resetCollectionTriggerRootState: () => initialState,
  },
  extraReducers(builder) {
    getSupplierCollectionTriggersExtraReducer(builder);
    createCollectionTriggerExtraReducer(builder);
    updateCollectionTriggerExtraReducer(builder);
    deleteCollectionTriggerExtraReducer(builder);
  },
});

export const { resetCollectionTriggerRootState } = collectionTriggerSlice.actions;
